import type { NSchedule } from '@app/types';
import { divideAmount } from '@app/utils';
import '@app/components/FinancialStatisticsComponent/styles/FinancialStatisticsComponent.desktop.scss';

export const FinancialStatisticsDropdownItems = ({
  financialStatistics,
  isCalendarComponent,
}: NSchedule.FinancialStatisticsDropdownItemsProps) => {
  const getDropdownItem = (
    name: string,
    value: number,
    key: number,
    isNeedCurrency: boolean,
    testId?: string,
    titleTestid?: string,
    amountDataTestid?: string
  ) => {
    return {
      key: key,
      label: (
        <div className="dropdown-item" data-testid={testId}>
          <div data-testid={titleTestid}>{name}</div>
          <div data-testid={amountDataTestid}>{` ${divideAmount(
            value.toLocaleString()
          )}`}</div>
        </div>
      ),
    };
  };

  if (!financialStatistics) return [];

  const calendarPageItems = [
    getDropdownItem(
      'Поступлений в кассы',
      financialStatistics.AmountTotal,
      1,
      true,
      'amount-in-cash-boxes'
    ),
    getDropdownItem(
      'Оплата наличными',
      financialStatistics.AmountCash,
      2,
      true,
      'cash-payment'
    ),
    getDropdownItem(
      'Оплата безналом',
      financialStatistics.AmountBank,
      3,
      true,
      'cashless-payment'
    ),
    getDropdownItem(
      'Записей на сумму',
      financialStatistics.RecordsAllAmount,
      5,
      true,
      'records-for-amount'
    ),
    getDropdownItem(
      'Выполнено на сумму',
      financialStatistics.RecordsPaidAmount,
      7,
      true,
      'done-for-amount'
    ),
    getDropdownItem(
      'Допродаж на сумму',
      financialStatistics.AdditionalPaymentAmount,
      8,
      true,
      'additional-payment-amount'
    ),
    getDropdownItem(
      'Отменено на сумму',
      financialStatistics.AmountNoVisited,
      11,
      true
    ),
  ];

  const recordPageItems = [
    getDropdownItem(
      'Кол-во записей',
      financialStatistics.CountRecord,
      4,
      false,
      '',
      'records-count-title',
      'records-count-value'
    ),
    getDropdownItem(
      'Записей на сумму',
      financialStatistics.RecordsAllAmount,
      5,
      true,
      'records-for-amount',
      'records-sum-title',
      'records-sum-value'
    ),
    getDropdownItem(
      'Записей выполнено',
      financialStatistics.CountRecordVisited,
      6,
      false,
      '',
      'records-completed-title',
      'records-completed-count'
    ),
    getDropdownItem(
      'Выполнено на сумму',
      financialStatistics.RecordsPaidAmount,
      7,
      true,
      'done-for-amount',
      'records-completed-sum-title',
      'completed-sum-value'
    ),
    getDropdownItem(
      'Допродаж на сумму',
      financialStatistics.AdditionalPaymentAmount,
      8,
      true,
      'additional-payment-amount',
      'upsells-sum-title',
      'upsells-sum-value'
    ),
    getDropdownItem(
      'Записей отменено',
      financialStatistics.CountRecordsNoVisited,
      9,
      false,
      '',
      'records-canceled-title',
      'records-canceled-count'
    ),
    getDropdownItem(
      'Отменено на сумму',
      financialStatistics.AmountNoVisited,
      10,
      true,
      '',
      'records-canceled-sum-title',
      'records-canceled-sum'
    ),
  ];

  if (isCalendarComponent) {
    return calendarPageItems;
  }

  return recordPageItems;
};
